import {
  DONATION_PROJECT_DETAILS_BY_ID_LOADING,
  DONATION_PROJECT_DETAILS_BY_ID_SUCCESS,
  DONATION_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";

import { Dispatch } from "redux";

import { listSingleItemService } from "services/listSingleItemService";
import { internalProjectsUrl } from "api/apiUrls";

export const donationProjectDetailsByIdActions =
  (id: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DONATION_PROJECT_DETAILS_BY_ID_LOADING, payload: true });
      const response = await listSingleItemService(
        `${internalProjectsUrl}`,
        `?id=${id}`
      );

      dispatch({
        type: DONATION_PROJECT_DETAILS_BY_ID_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: DONATION_PROJECT_DETAILS_BY_ID_FAILURE, payload: err });
    } finally {
      dispatch({
        type: DONATION_PROJECT_DETAILS_BY_ID_LOADING,
        payload: false,
      });
    }
  };
